<h1 class="text-3xl ps-4 first-letter:capitalize">
    {{ "DASHBOARD.QUOTATIONS" | translate }}
</h1>

<div class="p-4 w-full flex flex-row justify-center gap-4">
    <input type="search" class="w-full text-center h-12 bg-gray-100 max-w-2xl rounded-md overflow-hidden" [(ngModel)]="searchStr">
</div>

<div class="w-full h-full m-auto">
    <table class=" text-left capitalize max-w-screen-2xl w-full m-auto ">

        <thead class="bg-gray-50 h-fit">
            <th scope="col" class="px-6 py-4">{{ "DASHBOARD.QUOTATION_LISTING.QUOTATION" | translate }}</th>
            <th scope="col" class="px-6 py-4">{{ "DASHBOARD.QUOTATION_LISTING.CREATED" | translate }}</th>
            <th scope="col" class="px-6 py-4">{{ "DASHBOARD.QUOTATION_LISTING.CUSTOMER" | translate }}</th>
            <th scope="col" class="px-6 py-4">{{ "GLOBAL.EMAIL" | translate }}</th>
            <th scope="col" class="px-6 py-4">{{ "GLOBAL.PHONE_NUMBER" | translate }}</th>
            <th scope="col" class="px-2 py-4">{{ "GLOBAL.MESSAGE" | translate }}</th>
            <th scope="col" class="px-2 py-4">{{ "GLOBAL.ACTIONS" | translate }}</th>
        </thead>

        <tbody class="divide-y divide-gray-100 border-t border-gray-100 ">
            @if (!offersResource.hasValue()){
                <tr>
                    <th colspan="7" class="px-6 py-4 text-center">
                        <app-loader-element/>
                    </th>
                </tr>
            } @else {
                @for (offer of filteredOffers(); track offer){
                    <tr class="hover:bg-gray-50 group normal-case">
                        <th class="px-6 py-4 align-middle lowercase group-hover:font-bold">
                            <div>
                                <div>
                                    {{ offer.projectRecord.name }}
                                </div>
                                <div class="text-sm text-gray-500 flex gap-1">
                                    <span class="uppercase text-sm">ID: </span><span class="text-sm text-nowrap">{{ offer.projectRecord.id }}</span>
                                </div>
                            </div>
                        </th>
                        <td class="px-6 py-4">{{ offer.createdAt | date: "dd/MM/YYYY" }}</td>
                        <td class="px-6 py-4 text-nowrap">{{ offer?.company ?? ( 'DASHBOARD.PRIVATE_CONTRACTOR' | translate ) }}</td>
                        <td class="px-6 py-4">{{ offer.email }}</td>
                        <td class="px-6 py-4">{{ offer?.phone }} </td>
                        <td class="px-2 py-4 max-w-24 truncate cursor-pointer" (click)="onMessageOpen(offer)"> <span> {{ offer.description }} </span> </td>

                        <td class="px-2 py-4 ">

                            <button class="animate-infinite w-fit grid place-items-center group text-sm font-normal" [routerLink]="['']" [queryParams]="{project: offer.projectRecord.projectId, projectRecord:offer.projectRecord.id}" >
                                <img src="assets/images/icons/save.svg" class="group-hover:animate-wiggle-more" alt="" width="28" height="28"/>
                                <div>{{ "DASHBOARD.TO_PROJECT_RECORD" | translate }}</div>
                            </button>

                        </td>

                    </tr>
                }
            }


        </tbody>
    </table>
</div>